export const invoicesStatus = [
    'Estimate',
    'Approved',
    'In progress',
    'Completed',
    'Paid',
    'Delivered',
    'Declined',
];

export const invoicesStatusMap = {
    1: 'Estimate',
    2: 'Approved',
    3: 'In progress',
    4: 'Completed',
    5: 'Paid',
    6: 'Delivered',
    7: 'Declined',
};

export const invoicesStatusReverseMap = {
    'Estimate': 1,
    'Approved': 2,
    'In progress': 3,
    'Completed': 4,
    'Paid': 5,
    'Delivered': 6,
    'Declined': 7,
};

export const invoicesColorMap = {
    1: 'blue',
    2: 'cyan',
    3: 'orange',
    4: 'green',
    5: 'gold',
    6: 'purple',
    7: 'red'
};

export const invoicesHexColorMap = {
    1: '#40a9ff',
    2: '#36cfc9',
    3: '#ffa940',
    4: '#73d13d',
    5: '#ffc53d',
    6: '#9254de',
    7: '#ff4d4f'
};

export const PART = 'part';
export const LABOR = 'labor';